query UserDashboardCharts {
  userDashboardWebChartsList {
    chartPosition
    caption
    chartLayout
    isManualRefresh
    timedRefreshMilliseconds
  }
}
